import React, { Component } from 'react';
import withRouter from 'react-router/withRouter';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import isEmpty from 'lodash/isEmpty';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../components/all_feed/all_feed';
import { authorAllFeedAllStoriesRendered } from '../../../../redux/action_creators/author/author_all_feed_action_creators';
import authorISAllFeedActions from '../../../../redux/actions/author/async_author_is_all_feed_actions';
import { hideRecircAction } from '../../../../redux/actions/async_recirc_feed_actions';
import loadData from './author_page_state_manager';

// eslint-disable-next-line react/prefer-stateless-function
class Author extends Component {
  static loadData(store) {
    return loadData(store);
  }
  render() {
    const { authorPage, author, config } = this.props;
    const isLoading = get(authorPage, 'isLoading');

    if ((get(author, 'error') && !isLoading) || this.props.status === 404) {
      return (
        <section className="author-page">
          <article className="author-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (isLoading) {
      return (
        <section className="author-page">
          <article className="author-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(authorPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const authorName = get(author, 'name');
    const authorSlug = get(author, 'slug');
    const feedURL = `//${get(config, 'site', '')}.com/user/${authorSlug}/rss`;

    const page = get(this.props, 'authorAllFeed.page');
    const pageParam = get(this.props, 'match.params.page', false);
    const totalPages = get(this.props, 'authorAllFeed.totalPages');
    let isLastPage = Number(page) >= totalPages;

    if (!pageParam) {
      if (totalPages === 1) {
        isLastPage = true;
      }
      return (
        <section className="author-page">
          <section className="author-bio">
            {isEmpty(author) ? (
              ''
            ) : (
              <div className="author-bio__row">
                <div className="author-bio__stories-col">
                  <div className="author-bio__text-wrapper">
                    <h1 className="author-bio__author-name">{authorName}</h1>
                    <article
                      className="author-bio__author-desc"
                      dangerouslySetInnerHTML={{
                        __html: get(author, 'description')
                      }}
                    />
                  </div>
                  <div className="author-bio__rss-feed">
                    <a className="author-bio__rss-feed-url" href={feedURL}>
                      RSS
                    </a>
                  </div>
                </div>
                <div className="author-bio__ad-col">
                  <div>
                    <Ad
                      {...combinedAdModel}
                      noLazyLoad
                      pos="atf"
                      name="fixedrectangle"
                    />
                    <Ad
                      {...combinedAdModel}
                      noLazyLoad
                      pos="atf"
                      name="mobileparallax_1"
                    />
                  </div>
                </div>
              </div>
            )}
          </section>

          <AllFeed
            hasSlug={false}
            adModel={combinedAdModel}
            stories={get(this.props, 'authorAllFeed.posts')}
            allRendered={get(this.props, 'authorAllFeed.allRendered')}
            updateAction={authorAllFeedAllStoriesRendered}
            config={config}
            paginationEnabled={true}
            totalPages={totalPages}
            page={page}
            section={get(this.props, 'match.params.slug')}
            type="user"
            isLastPage={isLastPage}
            infiniteScrollEnabled={true}
            infiniteScrollAllFeedFetch={this.props.authorISAllFeedActions}
            infiniteScrollLoading={get(this.props, 'authorAllFeed.isLoading')}
            site={get(this.props, 'config.site')}
            hideRecircFeed={this.props.hideRecircFeed}
          />

          {get(this.props, 'authorAllFeed.isLoading') && <LoadingSpinner />}
          {!get(this.props, 'authorAllFeed.isEnabled') && (
            <div className="author-page__all-ad-container">
              <Ad {...combinedAdModel} pos="btf" name="flexiblebillboard_1" />
            </div>
          )}
        </section>
      );
    }
    return (
      <section className="author-page">
        <section className="author-bio">
          {isEmpty(author) ? (
            ''
          ) : (
            <div className="author-bio__row">
              <div className="author-bio__stories-col">
                <div className="author-bio__text-wrapper">
                  <h1 className="author-bio__author-name">{authorName}</h1>
                  <article
                    className="author-bio__author-desc"
                    dangerouslySetInnerHTML={{
                      __html: get(author, 'description')
                    }}
                  />
                </div>
              </div>
              <div className="author-bio__ad-col">
                <div>
                  <Ad
                    {...combinedAdModel}
                    noLazyLoad
                    pos="atf"
                    name="fixedrectangle"
                  />
                  <Ad
                    {...combinedAdModel}
                    noLazyLoad
                    pos="atf"
                    name="mobileparallax_1"
                  />
                </div>
              </div>
            </div>
          )}
        </section>
        <AllFeed
          site={get(this.props, 'config.site')}
          hasSlug={false}
          adModel={combinedAdModel}
          stories={get(this.props, 'authorAllFeed.posts')}
          allRendered={get(this.props, 'authorAllFeed.allRendered')}
          updateAction={authorAllFeedAllStoriesRendered}
          config={config}
          paginationEnabled={true}
          page={page + 1}
          section={get(this.props, 'match.params.slug')}
          type="user"
          isLastPage={isLastPage}
        />

        {get(this.props, 'authorAllFeed.posts.length') ? (
          <div className="author-page__all-ad-container">
            <Ad {...combinedAdModel} name="flexiblebillboard_5" />
            <Ad {...combinedAdModel} name="mobileparallax_2" />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    authorISAllFeedActions: authorISAllFeedActions(dispatch),
    hideRecircFeed: hideRecircAction(dispatch)
  };
}

function mapStateToProps(state = {}) {
  return {
    status: state.status.code,
    config: state.config || {},
    authorAllFeed: {
      page: get(state, 'authorAllFeed.data.page', 0),
      isEnabled: get(state, 'authorAllFeed.isEnabled'),
      isLoading: get(state, 'authorAllFeed.isLoading'),
      totalPages: get(state, 'authorAllFeed.data.totalPages', 0),
      posts: get(state, 'authorAllFeed.data.posts', []),
      allRendered: get(state, 'authorAllFeed.allRendered', false)
    },
    authorPage: state.authorPage || {
      ads: {
        baseConfig: {}
      }
    },
    author: get(state, 'author.data') || { error: true }
  };
}

Author.propTypes = {
  status: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  authorPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  author: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string
  }).isRequired,
  authorAllFeed: PropTypes.shape({
    page: PropTypes.number,
    isEnabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    totalPages: PropTypes.number,
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired,
  authorISAllFeedActions: PropTypes.func.isRequired,
  hideRecircFeed: PropTypes.func.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Author));
